import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit {
  isLoading:boolean = false;
  isEmailValid:boolean = false;
  isMobileValid:boolean = false;
  showBadEmail:boolean = true;
  showBadMobile:boolean = true;
  displayConfirmMessage:boolean = false;
  currentLanguage = 'en';
  shiftOptions:any = [
    { value: 'Days', title: 'Days', selected: false },
    { value: 'Nights', title: 'Nights', selected: false },
    { value: 'Weekends', title: 'Weekends', selected: false },
    { value: 'Flexible', title: 'Flexible', selected: false },
  ]
  interestOptions:any = [
    { value: 'Forklift', title: 'Forklift' },
    { value: 'General Warehouse', title: 'General Warehouse' },
    { value: 'Clerical', title: 'Clerical' },
    // { value: 'Technician', title: 'Technician' },
    // { value: 'Other', title: 'Other' },
  ]
  spanishShiftOptions:any = [
    { value: 'Days', title: 'Días', selected: false },
    { value: 'Nights', title: 'Noches', selected: false },
    { value: 'Weekends', title: 'Fines de semana', selected: false },
    { value: 'Flexible', title: 'Flexible', selected: false },
  ]
  spanishInterestOptions:any = [
    { value: 'Forklift', title: 'Forklift' },
    { value: 'General Warehouse', title: 'Almacén general' },
    { value: 'Clerical', title: 'Clerical' },
    // { value: 'Technician', title: 'Técnica/Técnico' },
    // { value: 'Other', title: 'Ortra/Otro' },
  ]
  languagePreferenceOptions:any = [
    { value: 'English', title: 'English' },
    { value: 'Spanish', title: 'Spanish' },
    { value: 'Other', title: 'Other' },
  ]
  spanishLanguagePreferenceOptions:any = [
    { value: 'English', title: 'Inglés' },
    { value: 'Spanish', title: 'Espanol' },
    { value: 'Other', title: 'Ortra/Otro' },
  ]
  stateOptions:any = [
    { value: 'Alabama', title: 'Alabama'},
    { value: 'Alaska', title: "Alaska"},
    { value: "Arizona", title: "Arizona"},
    { value: "Arkansas", title: "Arkansas"},
    { value: 'California', title: "California"},
    { value: 'Colorado', title: "Colorado"},
    { value: "Connecticut", title: "Connecticut"},
    { value: "Delaware", title: "Delaware"},
    { value: "Florida", title: "Florida"},
    { value: "Georgia", title: "Georgia"},
    { value: "Hawaii", title: "Hawaii"},
    { value: "Idaho", title: "Idaho"},
    { value: "Illinois", title: "Illinois"},
    { value: "Indiana", title: "Indiana"},
    { value: "Iowa", title: "Iowa"},
    { value: "Kansas", title: "Kansas"},
    { value: "Kentucky", title: "Kentucky"},
    { value: "Louisiana", title: "Louisiana"},
    { value: 'Maine', title: "Maine"},
    { value: "Maryland", title: "Maryland"},
    { value: "Massachusetts", title: "Massachusetts"},
    { value: "Michigan", title: "Michigan"},
    { value: "Minnesota", title: "Minnesota"},
    { value: "Mississippi", title: "Mississippi"},
    { value: "Missouri", title: "Missouri"},
    { value: "Montana", title: "Montana"},
    { value: "Nebraska", title: "Nebraska"},
    { value: "Nevada", title: "Nevada"},
    { value: "New Hampshire", title: "New Hampshire"},
    { value: 'New Jersey', title: "New Jersey"},
    { value: 'New Mexico', title: "New Mexico"},
    { value: 'New York', title: "New York"},
    { value: "North Carolina", title: "North Carolina"},
    { value: "North Dakota", title: "North Dakota"},
    { value: "Ohio", title: "Ohio"},
    { value: "Oklahoma", title: "Oklahoma"},
    { value: "Oregon", title: "Oregon"},
    { value: "Pennsylvania", title: "Pennsylvania"},
    { value: "Rhode Island", title: "Rhode Island"},
    { value: "South Carolina", title: "South Carolina"},
    { value: "South Dakota", title: "South Dakota"},
    { value: "Tennessee", title: "Tennessee"},
    { value: "Texas", title: "Texas"},
    { value: "Utah", title: "Utah"},
    { value: "Vermont", title: "Vermont"},
    { value: "Virginia", title: "Virginia"},
    { value: "Washington", title: "Washington"},
    { value: "West Virginia", title: "West Virginia"},
    { value: "Wisconsin", title: "Wisconsin"},
    { value: "Wyoming", title: "Wyoming"},
  ]
  regionOptions:any = [
    { value: 'Memphis/Olive Branch', title: 'Memphis/Olive Branch'},
    { value: 'Atlanta GA', title: "Atlanta GA"},
    { value: "Las Vegas NV", title: "Las Vegas NV"},
    { value: "Baltimore MD", title: "Baltimore MD"},
    { value: 'Dallas TX', title: "Dallas TX"},
    { value: 'Phoenix AZ', title: "Phoenix AZ"},
    { value: 'Charleston SC', title: 'Charleston SC'},
    { value: "Jacksonville FL", title: "Jacksonville FL"},
    { value: "Nashville TN", title: "Nashville TN"},
    { value: "Savannah GA", title: "Savannah GA"},
    { value: "Suffolk VA", title: "Suffolk VA"},
  ]
  hearAboutUsOptions = [
    { value: "Indeed", title: "Indeed"},
    { value: "ZipRecruiter", title: "ZipRecruiter"},
    { value: "Facebook", title: "Facebook"},
    { value: "Instagram", title: "Instagram"},
    { value: "TikTok", title: "TikTok"},
    { value: "Google", title: "Google"},
    { value: "Referral", title: "Referral"},
    { value: "Flyer/Community Event", title: "Flyer/Community Event"},
    { value: "Other", title: "Other"},
  ]
  spanishHearAboutUsOptions = [
    { value: "Indeed", title: "Indeed"},
    { value: "ZipRecruiter", title: "ZipRecruiter"},
    { value: "Facebook", title: "Facebook"},
    { value: "Instagram", title: "Instagram"},
    { value: "TikTok", title: "TikTok"},
    { value: "Google", title: "Google"},
    { value: "Referencia", title: "Referencia"},
    { value: "Volante/Evento Comunitario", title: "Volante/Evento Comunitario"},
    { value: "Otro", title: "Otro"},
  ]
  skillOptions = [
    { value: "RF Scanner", title: "RF Scanner"},
    { value: "Order Picker", title: "Order Picker"},
    { value: "Packer", title: "Packer"},
    { value: "Pick/Pack", title: "Pick/Pack"},
    { value: "Pallet Building", title: "Pallet Building"},
    { value: "Forklift Operator", title: "Forklift Operator"},
    { value: "Sit Down Forklift", title: "Sit Down Forklift"},
    { value: "Stand Up Forklift", title: "Stand Up Forklift"},
    { value: "Reach Truck", title: "Reach Truck"},
    { value: "Electric Pallet Jack (EPJ)", title: "Electric Pallet Jack (EPJ)"},
    { value: "Pallet Jack (Manual)", title: "Pallet Jack (Manual)"},
    { value: "Walkie Rider", title: "Walkie Rider"},
    { value: "Turret Truck", title: "Turret Truck"},
    { value: "Clamp Truck", title: "Clamp Truck"},
    { value: "Dock Stocker", title: "Dock Stocker"},
    { value: "Assembly", title: "Assembly"},
    { value: "Kitting", title: "Kitting"},
    { value: "Putaway", title: "Putaway"},
    { value: "Cycle Count", title: "Cycle Count"},
    { value: "Label Print and Apply", title: "Label Print and Apply"},
    { value: "Inbound Receiving", title: "Inbound Receiving"},
    { value: "Outbound", title: "Outbound"},
    { value: "Shipping", title: "Shipping"},
    { value: "Quality Inspection", title: "Quality Inspection"},
    { value: "WMS", title: "WMS"},
    { value: "Data Entry", title: "Data Entry"},
    { value: "Team Lead", title: "Team Lead"},
    { value: "Supervisor", title: "Supervisor"},
    { value: "Load / Unload", title: "Load / Unload"},
    { value: "Stand/Walk 8+ Hours", title: "Stand/Walk 8+ Hours"},
    { value: "Lift 50 lbs", title: "Lift 50 lbs"},
    { value: "Light Industrial", title: "Light Industrial"},
    { value: "Warehouse Clerk", title: "Warehouse Clerk"}
  ]
  spanishSkillOptions = [
    { value: "RF Scanner", title: "Escaneador"},
    { value: "Order Picker", title: "Pickear"},
    { value: "Packer", title: "Empacador"},
    { value: "Pick/Pack", title: "Pickeando y empacando"},
    { value: "Pallet Building", title: "Construyendo/ reparando Pallets"},
    { value: "Forklift Operator", title: "Conductor de Montacargas"},
    { value: "Sit Down Forklift", title: "Montacarga de sitdown"},
    { value: "Stand Up Forklift", title: "Montacarga de Stand up"},
    { value: "Reach Truck", title: "Montacarga de reach"},
    { value: "Electric Pallet Jack (EPJ)", title: "Montacarga de Electric Pallet Jack"},
    { value: "Pallet Jack (Manual)", title: "Montacarga de Pallet jack (manual)"},
    { value: "Walkie Rider", title: "Montacarga de walkie Rider"},
    { value: "Turret Truck", title: "Montacarga de Turret truck"},
    { value: "Clamp Truck", title: "Montacarga de Clamp"},
    { value: "Dock Stocker", title: "Dock Stocker"},
    { value: "Assembly", title: "Ensamblar"},
    { value: "Kitting", title: "Preparacion de Kits"},
    { value: "Putaway", title: "Almacenamiento"},
    { value: "Cycle Count", title: "Inventario/ Auditoria"},
    { value: "Label Print and Apply", title: "Imprimiendo y aplicando etiquetas"},
    { value: "Inbound Receiving", title: "Encargado de recibo"},
    { value: "Outbound", title: "Encargado de envio"},
    { value: "Shipping", title: "Encargado de envio"},
    { value: "Quality Inspection", title: "Inspecion de calidad"},
    { value: "WMS", title: "WMS"},
    { value: "Data Entry", title: "Entrada de datos"},
    { value: "Team Lead", title: "Lider de linea"},
    { value: "Supervisor", title: "Supervisor"},
    { value: "Load / Unload", title: "Cargar y deacargar"},
    { value: "Stand/Walk 8+ Hours", title: "Estar de pie/caminando 8+ hrs"},
    { value: "Lift 50 lbs", title: "Levantando 50 lbs"},
    { value: "Light Industrial", title: "Trabajo de industrial ligera"},
    { value: "Warehouse Clerk", title: "Auxiliar de almacen"}
  ]
  userDetails = {
    firstName: null,
    lastName: null,
    mobile: null,
    email: null,
    state: null,
    // city: null,
    region: null,
    languagePreference: null,
    otherLanguage: null,
    interestedPosition: null,
    otherPosition: null,
    preferredShifts: null,
    dateAvailable: null,
    workedBefore: null,
    dateWorked: null,
    additionalNotes: null,
    hearAboutUs: null,
    source: 'Instagram',
    referralName: null,
    smsOptIn: false,
    skills: []
  };

  constructor(private http: HttpClient) { }

  ngOnInit() {
  }

  get skillsValid(): boolean {
    return this.userDetails.skills && this.userDetails.skills.length > 0 && this.userDetails.skills.length <= 5;
  }

  onSkillChange(event: Event, value: string): void {
    const checked = (event.target as HTMLInputElement).checked;

    if (!this.userDetails.skills) {
      this.userDetails.skills = [];
    }

    if (checked) {
      this.userDetails.skills = [...this.userDetails.skills, value];
    } else {
      this.userDetails.skills = this.userDetails.skills.filter(s => s !== value);
    }
  }

  onEmailChange() {
    const emailregex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    if (!emailregex.test(this.userDetails.email)) {
      this.showBadEmail = true;
      this.isEmailValid = false;
    } else {
      this.showBadEmail = false;
      this.isEmailValid = true;
    }
  }

  onMobileChange() {
    const digitsOnly = (this.userDetails.mobile || '').replace(/\D/g, '').replace(/^1(\d{10})$/, '$1');
    const mobileregex = /^\d{10}$/;
    if (!mobileregex.test(digitsOnly)) {
      this.showBadMobile = true;
      this.isMobileValid = false;
    } else {
      this.userDetails.mobile = digitsOnly;
      this.showBadMobile = false;
      this.isMobileValid = true;
    }
  }

  submitForm(form: any): void {
    this.isLoading = true;
    console.log("!!DETIALS", this.userDetails);
    console.log("!!!FORM", form)
    console.log("!!!IS EMAIL AND MOBILE", this.isEmailValid, this.isMobileValid)
    if (this.isEmailValid && this.isMobileValid && form.valid) {
      console.log("!!!APPLYING")
      this.showBadEmail = false;
      this.showBadMobile = false;
      return this.apply(form)
    }
  }

  translateEmptyStringsToNull(obj) {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        if (obj[key] === '') {
          obj[key] = null;
        }
      }
    }
    return obj;
  }

  apply(form: any): any {
    const url = 'https://iJilityBHApp.newburypartnersapps.com/iJility-1.0/custom/form/submitIntakeForm?apiKey=4D661061-0100-1838-289984C044B6228C';
    let payload;
    payload = this.translateEmptyStringsToNull(this.userDetails);
    return new Promise((resolve, reject) => {
      this.http.post(url, payload).toPromise()
      .then((res) => {
        this.isLoading = false;
        form.reset();
        this.displayConfirmMessage = true;
        setTimeout(() => {
          this.displayConfirmMessage = false;
          window.location.href = "https://ijility.com/app-confirmation/?eid=s1YrUaoQzTTdm%2FP3uwIQRTYF7jKc8vVemiuNwpSowlWIxGCfvUtetGEe8j82721JNKdUOkfvYoiw%2FzxsH9T4kprH9K%2Bi%2BzkqXBZ8lsMbIVWGQS3Ehg%3D%3D"
        }, 3000)
      }, err => {
        this.isLoading = false;
        console.log("!!!ERR", err)
      })
    });
  }

}
